import { render } from "./left_menu.vue?vue&type=template&id=34c73dd6"
import script from "./left_menu.vue?vue&type=script&lang=js"
export * from "./left_menu.vue?vue&type=script&lang=js"

import "./left_menu.vue?vue&type=style&index=0&id=34c73dd6&lang=scss"
/* custom blocks */
import block0 from "./left_menu.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__